import supabase from "../supabase";

export const fetchItemsFromServer = async ({
  categoryName,
  page = 1,
  pageSize = 10,
  country = "All Countries",
  minRating = 0
}) => {
  
  const getTableData = async (tableName) => {
    // 1. Start the query
    let query = supabase.from(tableName).select('*');

    // 2. NEW: ONLY fetch claimed businesses from the businesses table
    // We don't apply this to 'bank' because 'bank' table doesn't have a status column
    if (tableName === 'businesses') {
      query = query.eq('status', 'claimed');
    }

    // 3. COLUMN NAME FIX
    const catColumn = (tableName === 'businesses') ? 'category' : 'cat';

    if (categoryName) {
      query = query.ilike(catColumn, `%${categoryName}%`);
    }

    // 4. Country Filter
    if (country && country !== "All Countries") {
      query = query.eq('country', country);
    }

    // 5. Rating Filter
    if (minRating > 0) {
      query = query.gte('trustscore', minRating);
    }

    const { data, error } = await query;

    // --- DEBUG LOG ---
    console.log(`--- Table: ${tableName} ---`);
    console.log(`Searching column: ${catColumn} | Status: ${tableName === 'businesses' ? 'claimed' : 'N/A'}`);
    console.log(`Results found:`, data?.length);
    if (error) console.error(`Supabase Error:`, error.message);

    return data || [];
  };

  try {
    const [bankData, bizData] = await Promise.all([
      getTableData('bank'),
      getTableData('businesses')
    ]);

    // Combine everything
    const allItems = [...bankData, ...bizData];

    // Deduplicate by URL
    const uniqueMap = new Map();
    allItems.forEach(item => {
      if (!uniqueMap.has(item.www)) uniqueMap.set(item.www, item);
    });
    
    const finalItems = Array.from(uniqueMap.values());

    // Strict Sorting (Score then Reviews)
    finalItems.sort((a, b) => {
      const scoreA = parseFloat(a.trustscore) || 0;
      const scoreB = parseFloat(b.trustscore) || 0;
      if (scoreB !== scoreA) return scoreB - scoreA;
      return (parseInt(b.reviews) || 0) - (parseInt(a.reviews) || 0);
    });

    const from = (page - 1) * pageSize;
    return { 
      data: finalItems.slice(from, from + pageSize), 
      totalCount: finalItems.length 
    };

  } catch (err) {
    console.error("❌ Global Fetch Error:", err);
    return { data: [], totalCount: 0 };
  }
};